import { $t, confirm, projectMetas, projectStore, userRole } from '@dabble/app';
import { writable } from '@dabble/data/stores/store';
import { Doc } from '@dabble/data/types';
import { mdiImageAlbum } from '@mdi/js';

export const coverImageDocId = writable('');

export const setCoverArt = [
  {
    key: 'novel_cover_art',
    icon: mdiImageAlbum,
    action: openDropCoverModal,
    hide: (doc: Doc) => (doc.image ? true : false),
    disabled: () => !userRole.get(),
  },
];

export const removeCoverArt = [
  {
    key: 'novel_cover_art_remove',
    icon: mdiImageAlbum,
    action: deleteCoverArt,
    hide: (doc: Doc) => (doc.image ? false : true),
    disabled: () => !userRole.get(),
  },
];

function openDropCoverModal(doc: Doc) {
  coverImageDocId.set(doc.id);
}

async function deleteCoverArt(doc: Doc) {
  const shouldDelete = await confirm(
    $t('novel_cover_art_remove_dialog_title'),
    $t('novel_cover_art_remove_dialog_text')
  );
  if (shouldDelete) {
    await projectMetas.update(projectStore.get().project.id, { image: null });
    await projectStore.updateDoc(doc.id, { image: null, icon: null });
  }
}
